import React from 'react';
import {
  ShimmerImage,
  ShimmerTypography,
  Shadow,
  Cushion,
  FlexContainer,
  Rectangle,
} from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import { getForcedViewParams } from './utils';

const PlaceholderCard = ({ forceView }) => {
  const { imagePreset, breakpoint } = getForcedViewParams(forceView);
  return (
    <Shadow>
      <Rectangle radius="rounded" style={{ overflow: 'hidden' }}>
        <FlexContainer
          flexDirection="row-reverse"
          alignItems="center"
          responsive={[
            { minWidth: breakpoint, props: { flexDirection: 'column', alignItems: 'initial' } },
          ]}
        >
          <Cushion
            component="div"
            right="small"
            responsive={[
              {
                minWidth: breakpoint,
                props: {
                  right: '0',
                },
              },
            ]}
          >
            <ShimmerImage preset={imagePreset} hasLoaded={false} loadingAspectRatio={1} />
          </Cushion>
          <FlexContainer flexDirection="column" style={{ flex: '1' }} component="div">
            <Cushion
              top="medium"
              horizontal="medium"
              bottom="large"
              style={{ flex: '1' }}
              component="div"
            >
              <ShimmerTypography preset="subtitle--large" />
            </Cushion>
            <Cushion bottom="medium" horizontal="medium" component="div">
              <ShimmerTypography preset="subtitle--small" />
            </Cushion>
          </FlexContainer>
        </FlexContainer>
      </Rectangle>
    </Shadow>
  );
};

PlaceholderCard.propTypes = {
  forceView: PropTypes.oneOf([null, 'landscape', 'portrait']),
};

PlaceholderCard.defaultProps = {
  forceView: null,
};

export default PlaceholderCard;
